import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from '@rocketlane/rocket-router';
export const AttachmentWorkspaceRedirect = ()=>{
    const { attachmentId } = useParams();
    return /*#__PURE__*/ _jsx(Navigate, {
        replace: true,
        to: `/attachments/${attachmentId}/workspace`
    });
};
